var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from '@angular/core';
import { NgFileDropDirective } from '../directives/ng-file-drop.directive';
import { NgFileSelectDirective } from '../directives/ng-file-select.directive';
var NgUploaderModule = /** @class */ (function () {
    function NgUploaderModule() {
    }
    NgUploaderModule = __decorate([
        NgModule({
            declarations: [
                NgFileSelectDirective,
                NgFileDropDirective
            ],
            exports: [
                NgFileSelectDirective,
                NgFileDropDirective
            ]
        })
    ], NgUploaderModule);
    return NgUploaderModule;
}());
export { NgUploaderModule };



//////////////////
// WEBPACK FOOTER
// C:/Users/re5pect/Desktop/siterepoProject/Admin panel/SiteRepoAdminPanel/~/ngx-uploader/lib/src/ngx-uploader/module/ngx-uploader.module.js
// module id = ../../../../ngx-uploader/lib/src/ngx-uploader/module/ngx-uploader.module.js
// module chunks = 3